'use client';

import { useSessionValues } from '@/providers/session-provider/hooks/use-session-values';
import { useGetCurrentUser } from '@/providers/session-provider/use-current-user';

const NO_GRANTS: readonly string[] = [];

/** Effective profile grants only. Feature rollout flags belong to consumers. */
export function useCustomFunctionalityPermissions() {
  const profile = useGetCurrentUser();
  const { userId, organizationId } = useSessionValues();
  const user = profile.data;
  const matchesSession =
    user &&
    (!userId || user.id === userId) &&
    (!organizationId ||
      !user.organization?.id ||
      user.organization.id === organizationId);
  const status = profile.isError
    ? 'error'
    : !matchesSession
      ? 'loading'
      : 'ready';
  const grants =
    status === 'ready' ? (user?.customFunctionalities ?? NO_GRANTS) : NO_GRANTS;
  const has = (grant: string) => status === 'ready' && grants.includes(grant);
  return {
    status,
    grants,
    has,
    hasAny: (required: readonly string[]) =>
      status === 'ready' && required.some(has),
    hasAll: (required: readonly string[]) =>
      status === 'ready' && required.every(has),
  };
}
